import { render, staticRenderFns } from "./twoWaterfall.vue?vue&type=template&id=a7be5960&scoped=true&"
import script from "./twoWaterfall.vue?vue&type=script&lang=js&"
export * from "./twoWaterfall.vue?vue&type=script&lang=js&"
import style0 from "./twoWaterfall.vue?vue&type=style&index=0&id=a7be5960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7be5960",
  null
  
)

export default component.exports